import React from 'react'
import { HashLink } from "react-router-hash-link"
import styled from "styled-components"
import media from "styled-media-query"

const IntroBtns = () => {

   return (
      <IntroBtnsStyles>
         <div className="wrap">
            <button>
               <HashLink smooth to="/introduce#rooms">
                  教室紹介
               </HashLink>
            </button>
            <button>
               <HashLink smooth to="/introduce#timetable">
                  授業時間割
               </HashLink>
            </button>
            <button>
               <HashLink smooth to="/introduce#events">
                  講習・イベント
               </HashLink>
            </button>
            <button>
               <HashLink smooth to="/introduce#voices">
                  合格者の声
               </HashLink>
            </button>
            <button>
               <HashLink smooth to="/introduce#profile">
                  塾長プロフィール
               </HashLink>
            </button>
         </div>
      </IntroBtnsStyles>
   )
}

const IntroBtnsStyles = styled.section`
   width: 100%;
   .wrap {
      width: 90%;
      margin: 0 auto;
      padding: 30px 0;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      ${media.lessThan("960px")`
         justify-content: space-evenly;
      `}
      ${media.lessThan("600px")`
         width: 80%;
         flex-direction: column;
      `}
      button {
         width: 16%;
         height: 50px;
         color: #FF3D01;
         padding: 0;
         border: 3px solid #FF3D01;
         border-radius: 25px;
         background-color: #fff;
         font-size: 1.6rem;
         box-shadow: 0 3px 6px #00000029;
         transition: 0.2s;
         &:hover {
            cursor: pointer;
            background-color: #FF3D01;
            color: #fff;
         }
         ${media.lessThan("960px")`
            width: 47%;
            &:nth-child(3), &:nth-child(4), &:nth-child(5) {
               margin-top: 10px;
            }
         `}
         ${media.lessThan("600px")`
            width: 100%;
            margin-top: 10px;
         `}
         a {
            display: block;
            width: 100%;
            line-height: 44px;
         }
      }
   }
`

export default IntroBtns